import { featuredItems } from '@/mocks/homeData';

export default function FeaturedItems() {
  return (
    <section className="relative py-16 md:py-20 bg-foreground-950 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20charcoal%20background%20with%20very%20subtle%20organic%20grain%20texture%20and%20barely%20visible%20soft%20irregular%20lines%2C%20moody%20atmospheric%20base%20layer%2C%20rich%20deep%20obsidian%20black%20with%20hints%20of%20warm%20dark%20brown%20micro-texture%2C%20no%20distinct%20shapes%20or%20objects%2C%20purely%20textural%20dark%20surface%20for%20overlay%20use%2C%20sophisticated%20understated%20material%20feel&width=1600&height=800&seq=dark-texture-v3-x3&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-400 border border-accent-500/30 rounded-full px-3 py-1 font-label mb-4">
              Trending Now
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white max-w-xl leading-tight">
              Hot Spreadsheet Items
            </h2>
          </div>
          <p className="text-white/50 text-sm max-w-xs">
            Today&apos;s most popular finds across all platforms. Updated in real-time from verified seller lists.
          </p>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 md:px-6 snap-x snap-mandatory">
          {featuredItems.map((item, idx) => (
            <div
              key={idx}
              className="flex-shrink-0 w-[220px] md:w-[260px] snap-start bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="h-[180px] md:h-[220px] relative overflow-hidden bg-secondary-100">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 bg-foreground-950">
                <p className="text-white text-sm font-semibold truncate font-label">{item.name}</p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-accent-400 text-xs font-medium">{item.platform}</span>
                  <span className="text-white/60 text-xs">{item.price}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}